import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { FaIdCard, FaEnvelope } from "react-icons/fa";

const CardProfile = ({ father }) => {
    return (
        <Card className="shadow-sm border-0">
            <Card.Body>
                <Row >
                    <Col xs="auto">
                        <FaIdCard size={20} className="text-primary me-2" />
                    </Col>
                    <Col>
                        <strong className="text-dark">Nombre completo:</strong><br />
                        <span>{father.firstName} {father.lastName}</span>
                    </Col>
                </Row>
                <Row >
                    <Col xs="auto">
                        <FaIdCard size={20} className="text-primary me-2" />
                    </Col>
                    <Col>
                        <strong className="text-dark">DNI:</strong><br />
                        <span>{father.dni}</span>
                    </Col>
                </Row>
                <Row >
                    <Col xs="auto">
                        <FaEnvelope size={20} className="text-primary me-2" />
                    </Col>
                    <Col>
                        <strong className="text-dark">Email:</strong><br />
                        <span>{father.email}</span>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

CardProfile.propTypes = {
    father: PropTypes.object.isRequired,
};

export default CardProfile;